import {Grid, GridItem, Text} from '@constellation/core';
import {memo} from 'react';
import {TAGGING_FIELDS} from '../../../../../enums/tagging/index.js';
import {getPsrLabel} from '../../../../../utils/index.js';
import CallToActionBox from './CallToActionBox.js';

const CallToActionGuideLine = () => (
  <>
    <Grid>
      <Text
        color='brand'
        marginBottom='05'
        marginLeft='04'
        marginTop='05'
        size='s5'
      >
        {getPsrLabel('callToActionGuideLines.heading')}
      </Text>
    </Grid>
    <Grid>
      <GridItem lg={6} md={4}>
        <CallToActionBox
          availabilitynote={getPsrLabel(
            'callToActionGuideLines.existingUser.availabilityNote'
          )}
          heading={getPsrLabel('callToActionGuideLines.existingUser.heading')}
          phonenumber={getPsrLabel(
            'callToActionGuideLines.existingUser.phoneNumber'
          )}
          taggingLabel={TAGGING_FIELDS.EXISTING_PHONE_NUMBER}
        />
      </GridItem>
      <GridItem lg={6} md={4}>
        <CallToActionBox
          availabilitynote={getPsrLabel(
            'callToActionGuideLines.newUser.availabilityNote'
          )}
          heading={getPsrLabel('callToActionGuideLines.newUser.heading')}
          phonenumber={getPsrLabel(
            'callToActionGuideLines.newUser.phoneNumber'
          )}
          taggingLabel={TAGGING_FIELDS.NEW_CARDENET_PHONE_NUMBER}
        />
      </GridItem>
    </Grid>
  </>
);

export default memo(CallToActionGuideLine);
